export const getTrackers = (auth) => {
  return auth.fetch('/fleet', { method: 'GET' });
}

export const getTrackerInfo = (auth, id) => {
  return auth.fetch(`/fleet/${id}`, { method: 'GET' });
}

export const assignTracker = (auth, id, values) => {
  return auth.fetch(`/fleet/${id}`, { method: 'PUT', body: JSON.stringify(values) });
}

export const getUnits = (auth) => {
  return auth.fetch('/trucks', { method: 'GET' });
}

export const saveUnit = (auth, unit) => {
  return auth.fetch('/trucks', { method: 'POST', body: JSON.stringify(unit) });
}

export const getTrailers = (auth) => {
  return auth.fetch('/trailers', { method: 'GET' });
}

export const saveTrailer = (auth, trailer) => {
  return auth.fetch('/trailers', { method: 'POST', body: JSON.stringify(trailer) });
}



// WEBPACK FOOTER //
// ./src/services/FleetService.js